import React, {FC, useState} from 'react';
import {CardFormComponentProps} from './types';
import {formatCreditCardNumber, formatExpirationDate, formatCVC} from './helpers';

import {eyeIcon} from '../../images/svgIcons';
import CustomInput from '../customInput';

const CreditCardFormComponent: FC<CardFormComponentProps> = ({
  cardData,
  onFieldChange,
  onFieldBlur,
  onFieldFocus,
  disabled,
  fieldError,
}) => {
  const [showCVV, setShowCVV] = useState(false);
  return (
    <>
      <div className="profile-payment-inputs" style={{opacity: disabled ? '0.5' : 1}}>
        <div className="text-left">
          <CustomInput
            label={'Cardholder’s Name'}
            name="name"
            placeholder="Name on the card"
            value={cardData.name}
            onChange={onFieldChange}
            onFocus={onFieldFocus}
            onBlur={onFieldBlur}
            required
            disabled={disabled}
            error={fieldError && !cardData.name ? 'true' : ''}
          />
        </div>
        <div className="text-left">
          <CustomInput
            label={'Credit/Debit Card Number'}
            name="number"
            placeholder="Card number"
            value={formatCreditCardNumber(cardData.number)}
            onChange={onFieldChange}
            onFocus={onFieldFocus}
            onBlur={onFieldBlur}
            required
            disabled={disabled}
            error={fieldError && !cardData.number ? 'true' : ''}
          />
        </div>
        <div className="row text-left">
          <div className="col-12 col-lg-6 col-sm-6">
            <CustomInput
              label={'Expiration'}
              name="expiry"
              placeholder="MM/YY"
              value={formatExpirationDate(cardData.expiry)}
              onChange={onFieldChange}
              onFocus={onFieldFocus}
              onBlur={onFieldBlur}
              required
              disabled={disabled}
              error={fieldError && !cardData.expiry ? 'true' : ''}
            />
          </div>
          <div className="col-12 col-lg-6 col-sm-6 m_t_6">
            <div className="form-item custom-input cvc-wrapper">
              <span className="form-item-label">Security code</span>
              <div className="input-wrapper">
                <input
                  type={showCVV ? 'text' : 'password'}
                  name="cvc"
                  placeholder="CVV/CVC"
                  className={`input-field cvc-input ${fieldError && !cardData.cvc ? 'error-border' : ''}`}
                  value={formatCVC(cardData.cvc, cardData.number)}
                  onChange={onFieldChange}
                  onFocus={onFieldFocus}
                  onBlur={onFieldBlur}
                  required
                  disabled={disabled}
                />
                <div
                  className={`eye-icon ${showCVV ? ' active' : ''}`}
                  onClick={e => !disabled && setShowCVV(!showCVV)}
                >
                  {eyeIcon}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditCardFormComponent;
